<div [ngClass]="{ 'container' : !(isMobile | async) }" [class.mx-4]="isMobile | async">
  <!-- Filters -->
  <div class="row rounded p-3 mb-3 mt-3 bg-white shadow-sm" id="top">
    <div class="col-md-4">
      <form class="search-form">
        <div class="form-group has-search">
          <fa-icon [icon]="faSearch" class="form-control-feedback"></fa-icon>
          <input type="text" class="form-control" placeholder="Profile Search" autocomplete="false"
            [formControl]="searchField" autocomplete="off" [ngbTypeahead]="autoComplete"
            [resultFormatter]="autoCompleteFormatter" [inputFormatter]="autoCompleteFormatter"
            (selectItem)="search(false, false, $event.item)" (keyup.enter)="search(false, false, searchField.value)"
            aria="combobox">
        </div>
      </form>
    </div>
    <div class="col-md-8 d-flex"
      [ngClass]="!(isMobile | async) ? 'justify-content-end align-items-center' :  'flex-column'">
      <!-- <div ngbDropdown class="d-inline-block mb-3">
        <button class="btn btn-outline-secondary" [ngClass]="{ 'px-5' : !(isMobile | async) }" id="school"
          ngbDropdownToggle [ngClass]="{ 'ml-3' : isMobile | async }">School Filter</button>
        <div ngbDropdownMenu aria-labelledby="school">
          <ng-container *ngFor="let school of (directoryFilter | async)?.schools">
            <button class="truncate-label" ngbDropdownItem (click)="search(false, true, school)">{{ school }}</button>
          </ng-container>
        </div>
      </div> -->

      <div class="form-group d-flex flex-row filter-group">
        <div class="mr-3">
          <select class="form-control" (change)="search(false, true, $event.target.value)">
            <option class="text-muted disabled" value="">School</option>
            <ng-container *ngFor="let school of (directoryFilter | async)?.schools">
              <option class="truncate-label" [value]="school">{{ school }}</option>
            </ng-container>
          </select>
        </div>

        <select class="form-control" (change)="search(true, false, $event.target.value)">
          <option class="text-muted disabled" value="">Department</option>
          <ng-container *ngFor="let dept of (directoryFilter | async)?.departments">
            <option class="truncate-label" [value]="dept">{{ dept }}</option>
          </ng-container>
        </select>
      </div>

      <!-- <div ngbDropdown class="d-inline-block ml-3 mb-3">
        <button class="btn btn-outline-secondary" [ngClass]="{ 'px-5' : !(isMobile | async) }" id="dept"
          ngbDropdownToggle>Department Filter</button>
        <div ngbDropdownMenu aria-labelledby="dept">
          <ng-container *ngFor="let dept of (directoryFilter | async)?.departments">
            <button class="truncate-label" ngbDropdownItem (click)="search(true, false, dept)">{{ dept }}</button>
          </ng-container>
        </div>
      </div> -->
    </div>
    <div class="ml-3" *ngIf="appliedFilter | async as filter" [ngClass]="{ 'mt-3' : isMobile | async }">
      <div class="badge badge-pill badge-info badge-filter">
        <span class="truncate-label">{{ filter }}</span>
        <fa-icon [icon]="faTimes" class="ml-3" (click)="clearFilter()"></fa-icon>
      </div>
    </div>
  </div>
  <!-- Filters -->


  <!-- Listing -->
  <ng-container *ngIf="!isLoading">
    <div *ngFor="let item of directory | async | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize;"
      class="row rounded p-3 mb-3 mt-3 listing-item shadow-sm" style="background-color: #fff;">
      <app-listing class="w-100" [listing]="item"></app-listing>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <div *ngFor="let num of skeletonLoaders" class="row rounded p-3 mb-3 mt-3 listing-item shadow-sm"
      style="background-color: #fff;">
      <div class="col-md-2">
        <ngx-skeleton-loader count="1" appearance="circle" [theme]="{
          width: '100px',
          height: '150px',
          'border-radius': '4px'
        }">
        </ngx-skeleton-loader>
      </div>
      <div class="col-md-4">
        <ngx-skeleton-loader count="5"></ngx-skeleton-loader>
      </div>
    </div>
  </ng-container>
  <!-- Listing -->

  <!-- Pagination -->
  <div class="row mt-3">
    <div class="col-md-12 d-flex justify-content-end">
      <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="(directory | async)?.length"
        [directionLinks]="false" [boundaryLinks]="true" [maxSize]="5" [rotate]="true" [ellipses]="false">
      </ngb-pagination>
    </div>
  </div>
  <!-- Pagination -->
</div>